import { emailValidator } from "./emailValidator.js";
import { passwordMatch, passwordValidator } from "./passwordValidator.js";

export default function createValidator(t) {
  return {
    email: (email) => emailValidator(email, t),
    password: (password) => passwordValidator(password, t),
    confirmPassword: (password, confirmPassword) => passwordMatch(password, confirmPassword, t)
  };
}